import DashboardLayouts from "../../components/Layouts/DashboardLayouts";
import SectionHead from "../../components/common/SectionHead";

const Setting = () => {
  return (
    <div className="px-7 mt-5">
      <SectionHead title="All Settings" paragraph="Projects setting here" />
      <div className="flex justify-center items-center mt-40 text-gray-400 font-bold text-3xl">
        Comming soon ...
      </div>
    </div>
  );
};

export default Setting;
